// 生成min-max之间的随机数
export const getRandomArbitrary = (min, max) => {
  return Math.random() * (max - min) + min
}
